// Getters
export const assetsMaturity = (state) => {
  return state.assetsMaturity.data || []
}
export const assetsMaturityLoading = (state) => {
  return state.assetsMaturity.loading
}
export const assetsMaturityLastUpdate = (state) => {
  return state.assetsMaturity.lastUpdate
}

export const assetsApproaching = (state) => {
  return state.assetsApproaching.data || []
}
export const assetsApproachingLoading = (state) => {
  return state.assetsApproaching.loading
}
export const assetsApproachingLastUpdate = (state) => {
  return state.assetsApproaching.lastUpdate
}
export const exportTaxes = (state) => {
  return state.exportTaxes.data || []
}
export const exportTaxesLoading = (state) => {
  return state.exportTaxes.loading
}
export const exportTaxesLastUpdate = (state) => {
  return state.exportTaxes.lastUpdate
}

export const carteiraAdministrada = (state) => {
  return state.carteiraAdministrada.data || []
}
export const carteiraAdministradaLoading = (state) => {
  return state.carteiraAdministrada.loading
}
export const carteiraAdministradaLastUpdate = (state) => {
  return state.carteiraAdministrada.lastUpdate
}

